<template>
    <div>
        <fpzInvacc-common readonly></fpzInvacc-common>
    </div>
</template>
<script>
import fpzInvaccCommon from './fpzInvaccCommon';
export default {
    name: 'fpzInvaccAdd',
    components: {
        fpzInvaccCommon
    },
    data () {

    }
}
</script>